import EntityModel from '@/common/models/entity-model';
import RuleActionModel from '@/common/models/rules/actions/rule-action-model';

export class DisplayChoiceModel extends EntityModel {
    hydrate({
        langIso = null,
        content = null,
    } = {}) {
        this.langIso = langIso;
        this.content = content;
    }

    /**
     * Shared by bump offers and display-other-choices actions
     * @return {DisplayChoiceModel[]}
     */
    static getDefaultChoices() {
        return [
            new DisplayChoiceModel({langIso: 'en'}),
            new DisplayChoiceModel({langIso: 'fr'}),
        ];
    }

    getPayload() {
        return {
            langIso: this.langIso,
            content: this.content,
        };
    }
}

export default class DisplayOtherChoicesActionModel extends RuleActionModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        ({choices: this.choices = []} = fields);
        this.choices = this.choices.length
            // map existing
            ? this.choices.map(v => new DisplayChoiceModel(v))
            // or use defaults
            : DisplayChoiceModel.getDefaultChoices();
    }

    getPayload() {
        return {
            ...super.getPayload(),
            choices: this.choices.map(v => v.getPayload()),
        };
    }
}
